export const colorMap = {
    MAIN_PRICE: "color.surface.data.categorical.1",
    NOTARY_FEE: "color.surface.data.categorical.2",
    REAL_ESTATE_TRANSFER_TAX: "color.surface.data.categorical.3",
    BROKERAGE_FEE: "color.surface.data.categorical.4",
    LAND_REGISTRY_ENTRY: "color.surface.data.categorical.5",
    PARKING_PRICE: "color.surface.data.categorical.disabled",
    BASE_RENT: "color.surface.data.categorical.1",
    OPERATING_COSTS: "color.surface.data.categorical.2",
    HEATING_COSTS: "color.surface.data.categorical.3",
    PARKING_RENT: "color.surface.data.categorical.4",
    VALUE_ADDED_TAX: "color.surface.data.categorical.5",
};
